module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/icon-badge-02-3dcf4ad49ce812f113cd35bea728ecbb.svg";